import Swiper from 'swiper';

export default function () {
    new Swiper('.c-swiper', {
        effect: 'fade',
        loop: true,
        autoplay: true,
        speed: 1000
    });
}
